module.exports = __webpack_public_path__ + "img/logo_eduloc360.1308efb7.png";